import axios from "axios";
import { API } from "../../backend";
import authHeader from "../auth-header"
const getContract = (state) => {
  return axios.get(API + "contracts/contract-edit/"+state+"/",{headers: authHeader(),});
};
const editContract = (state,contract_number,contract_term,start_date,end_date,paymentstartdate,address_id,contract_type,loanamount,
    iir,
    interestcalculationmethod,
    repaymentprocedure,
    timecountingmethod,
    paymentmethod,
    deposit_amount,
    feesontime,
    tax_rate_rent,
    tax_rate_fee,
  customer_id,
  attribute,
  paymentfrequency,
  paymentrule,
  achPayments,
  achAccount,
  appOriginator,
  source,
  salesRep,
  subcompany,
  line_of_business,
  interest_only_payments,
  contractTerms,
  interest_rate_type,
  base_rate,
  margin
  ) => {
    return axios.post(API + "contracts/contract-edit/" +state+"/", {
        contract_number,
        contract_term,
        start_date,
        end_date,
        paymentstartdate,
        address_id,
        contract_type,
        loanamount,
        iir,
        interestcalculationmethod,
        repaymentprocedure,
        timecountingmethod,
        paymentmethod,
        deposit_amount,
        feesontime,
        tax_rate_rent,
        tax_rate_fee,
        customer_id,
        attribute,
        paymentfrequency,
        paymentrule,
        enable_ach: achPayments ? "Y" : "N",
        ach_account_id: achAccount || null,
        appOriginator,
        source,
        salesRep,
        subcompany,
        line_of_business,
        interest_only_payments,
        termsCondition: contractTerms,
        interest_rate_type: interest_rate_type,
        base_rate: interest_rate_type === "Floating" ? base_rate : 0,
        margin: interest_rate_type === "Floating" ? margin : 0,
    },{headers: authHeader(),});
  };
const EditContractLoanService = {
    getContract,
    editContract,
  };
  export default EditContractLoanService;